//src/components/AlbumList.js//
import React, { useEffect, useState } from 'react';
//import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';
import { Grid, Card, CardContent, CardMedia} from '@mui/material';
import { Link } from 'react-router-dom';
import {  Typography } from '@mui/material';
import axios from 'axios';
import BASE_URL from '../config';
const AlbumList = () => {
  const [albums, setAlbums] = useState([]);
  /* const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); */
  /* useEffect(() => {
    axios.get('http://localhost:6100/api/albumsg')
      .then(response => setAlbums(response.data))
      .catch(error => console.error('Error fetching albums:', error));
  }, []); */
 // Fetch albums on component mount
 const fetchAlbums = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/albumsg`);
      setAlbums(response.data);
    } catch (error) {
      console.error('Error fetching albums:', error);
    }
  };

  useEffect(() => {
    fetchAlbums();
  }, []);

  // Handle page change
  /* const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
 */
   // Function to format date as dd/mm/yyyy
   const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert the string to a Date object
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month and pad with leading zero if necessary
    const year = date.getFullYear(); // Get the year
    return `${day}/${month}/${year}`; // Return the formatted date as dd/mm/yyyy
  };

  // Get the rows to display based on pagination
  //const rows = albums.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return (

    <div style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>Photo Albums</Typography>
      <Grid container spacing={4}>
        {albums.map((album) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={album.album_id}>
            <Card>
              <Link to={`/photo-gallery/${album.album_id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={`${BASE_URL}${album.firstImage}`}
                  alt={album.album_name}
                />
                <CardContent>
                  <Typography variant="h6">{album.album_name}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    Created on: {formatDate(album.created_at)}
                  </Typography>
                </CardContent>
              </Link>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* <TableContainer component={Paper}>
        <Table>
          <TableHead>
          <TableRow>
              
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Album Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Image</TableCell>
              <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Created Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((album) => (
              <TableRow hover key={album.album_id}>
                <TableCell>
                  <Link to={`/photo-gallery/${album.album_id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    {album.album_name}
                  </Link>
                </TableCell>
                 <TableCell>
                  <img
                    src={`https://apiviztech.in:6100${album.firstImage}`}
                    alt={album.album_name}
                    width="100"
                    style={{ borderRadius: '8px' }}
                  />
                </TableCell>
                <TableCell>{formatDate(album.created_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
 */}
      {/* <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={albums.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
    </div>


    
    
  );
};

export default AlbumList;
